// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'edit-user-info-modal',
    templateUrl: './edit-user-info-modal.component.html',
    styleUrls: ['./edit-user-info-modal.component.scss'],
})
export class EditUserInfoModalComponent {
    public userInfo: any;
    public title: string;
    public allowExistingUser = false;
    public offLimitsUserIds: number[] = [];

    constructor(
        private dialogRef: MatDialogRef<EditUserInfoModalComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {
        this.title = this.data.title;
        this.userInfo = this.data.user;
        this.allowExistingUser = this.data.allowExistingUser;
        this.offLimitsUserIds = this.data.offLimitsUserIds || [];
    }

    public closeModal(success: any) {
        this.dialogRef.close(success);
    }

    public close() {
        this.dialogRef.close();
    }
}
